import { animate, state, style, transition, trigger } from '@angular/animations'
import { CommonModule } from '@angular/common'
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { SharedModule } from '@shared/shared.module'
import { NgxMaskDirective } from 'ngx-mask'

@Component({
  selector: 'scope-ui-box-input',
  standalone: true,
  imports: [CommonModule, FormsModule, SharedModule, NgxMaskDirective],
  templateUrl: './scope-ui-box-input.component.html',
  styleUrls: ['./scope-ui-box-input.component.scss'],
  animations: [
    trigger('expandCollapse', [
      state('collapsed', style({ width: '200px' })),
      state('expanded', style({ width: '400px' })),
      transition('collapsed <=> expanded', [animate('300ms ease-in-out')]),
    ]),
  ],
})
export class ScopeUiBoxInputComponent {
  @Input() initialValue: number
  @Input() formClass?: string
  @Input() isDecimal?: boolean
  @Input() min?: number
  @Input() max?: number
  @Input() disabled = true
  @Input() confirm = false
  @Input() viewValue: string
  @Input() set formatDisplayValue(value: (val: number) => string | number) {
    if (value) {
      this.disableMask = true
      this._formatDisplayValue = value
    }
  }
  @Input() set parseDisplayValue(value: (val: string | number) => number) {
    if (value) this._parseDisplayValue = value
  }

  @Output() onUpdateValue = new EventEmitter<number>()

  @ViewChild('boxInput') boxInput: ElementRef<HTMLInputElement>

  _formatDisplayValue: (val: number) => string | number = (val: number) => val
  _parseDisplayValue: (val: string | number) => number = (val: string | number) => parseFloat(val.toString())

  edit = false
  disableMask = false

  onManualInput($event: string) {
    if ($event.length) return
    const newValue = this._parseDisplayValue($event)
    if (newValue != this.initialValue) {
      this.initialValue = this._parseDisplayValue($event)
      if (!this.confirm) {
        this.onUpdateValue.emit(this.initialValue)
      }
    }
  }

  onEdit() {
    this.edit = true
    setTimeout(() => {
      if (this.boxInput) this.boxInput.nativeElement.focus()
    })
  }

  onConfirmInput() {
    this.edit = false

    if (this.confirm) this.onUpdateValue.emit(this.initialValue)
  }
}
